
import { create } from 'zustand';

interface BlogState {
  activePanel: 'settings' | 'revisions' | null;
  unsavedChanges: boolean;
  previewMode: boolean;
  setActivePanel: (panel: 'settings' | 'revisions' | null) => void;
  setUnsavedChanges: (val: boolean) => void;
  setPreviewMode: (val: boolean) => void;
}

export const useBlogStore = create<BlogState>((set) => ({
  activePanel: 'settings',
  unsavedChanges: false,
  previewMode: false,
  setActivePanel: (panel) => set({ activePanel: panel }),
  setUnsavedChanges: (val) => set({ unsavedChanges: val }),
  setPreviewMode: (val) => set({ previewMode: val }),
}));
